import type { LucideIcon } from "lucide-react";
import {
  Bell,
  Calendar,
  CheckSquare,
  Clock,
  FileText,
  HandCoins,
  Megaphone,
  Package,
  Send,
  UserPlus,
} from "lucide-react";

export interface InAppNotificationMeta {
  category: string;
  icon: LucideIcon;
}

const SLUG_META: Record<string, InAppNotificationMeta> = {
  shift_assigned_in_app: { category: "Scheduling", icon: Calendar },
  shift_removed_in_app: { category: "Scheduling", icon: Calendar },
  shift_time_changed_in_app: { category: "Scheduling", icon: Calendar },
  shift_dropped_in_app: { category: "Scheduling", icon: Calendar },
  program_drafted_in_app: { category: "Programs", icon: FileText },
  hours_rejected_in_app: { category: "Hours", icon: Clock },
  hours_approved_in_app: { category: "Hours", icon: Clock },
  event_manager_rsvp_update_in_app: { category: "Events", icon: Calendar },
  cross_org_referral_in_app: { category: "Cases", icon: Send },
  task_assigned_in_app: { category: "Task", icon: CheckSquare },
  task_due_tomorrow_in_app: { category: "Task", icon: CheckSquare },
  task_overdue_in_app: { category: "Task", icon: CheckSquare },
  case_assigned_in_app: { category: "Cases", icon: Send },
  case_note_added_in_app: { category: "Cases", icon: Send },
  service_log_decided_in_app: { category: "Cases", icon: Send },
  member_application_submitted_in_app: { category: "Community", icon: UserPlus },
  member_application_decided_in_app: { category: "Community", icon: UserPlus },
  expense_submitted_in_app: { category: "Finance", icon: HandCoins },
  expense_decided_in_app: { category: "Finance", icon: HandCoins },
  bill_submitted_in_app: { category: "Finance", icon: HandCoins },
  bill_decided_in_app: { category: "Finance", icon: HandCoins },
  timesheet_submitted_in_app: { category: "Hours", icon: Clock },
  timesheet_decided_in_app: { category: "Hours", icon: Clock },
  inventory_decided_in_app: { category: "Inventory", icon: Package },
  grant_budget_submitted_in_app: { category: "Grants", icon: FileText },
  announcement_published_in_app: { category: "News", icon: Megaphone },
};

const DEFAULT_META: InAppNotificationMeta = { category: "Update", icon: Bell };

export function metaForInAppSlug(slug: string | undefined): InAppNotificationMeta {
  if (!slug) return DEFAULT_META;
  return SLUG_META[slug] ?? DEFAULT_META;
}
